import React from "react";
import { Route } from "react-router-dom";

import PrivacyPolicy from "../pages/Static/PrivacyPolicy";
import Terms from "../pages/Static/Terms";
import ContactUs from "../pages/Static/ContactUs";
import AboutUs from "../pages/Static/AboutUs";

const StaticRoutes = () => (
  <>
    <Route path="privacy-policy" element={<PrivacyPolicy />} />
    <Route path="terms" element={<Terms />} />
    <Route path="contact-us" element={<ContactUs />} />
    <Route path="about-us" element={<AboutUs />} />
  </>
);

export default StaticRoutes;